import { render, staticRenderFns } from "./DocumentsManualsSelectionView.vue?vue&type=template&id=247fde4a"
import script from "./DocumentsManualsSelectionView.vue?vue&type=script&lang=js"
export * from "./DocumentsManualsSelectionView.vue?vue&type=script&lang=js"
import style0 from "./DocumentsManualsSelectionView.vue?vue&type=style&index=0&id=247fde4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports